import '@total-typescript/ts-reset';
import 'config/dayjs.config';
import 'config/i18next.config';
import 'config/sentry.config';
import { createRoot } from 'react-dom/client';
import pkg from '../package.json';
import App from './app/App';
import './index.css';
import * as serviceWorker from './serviceWorker';

console.info('Fiter version:', pkg.version);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
